import { DashboardOldComponent } from './dashboard/dashboard-old.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { InformationRouting } from './information/information.routing';
import { LoginComponent } from './login/login.component';
import { ReportsRouting } from './reports/reports.routing';
import { RequestRouting } from './requests/request.routing';
import { RequestsComponent } from './requests/requests.component';
import { SettingsComponent } from './settings/settings.component';
//import { SosPanelComponent } from './sos-panel/sos-panel.component';
import { SupportDeskRouting } from './support-desk/suportdesk.routing.component';
import { LiveVehicleTrackingComponent } from './live-tracking/live.tracking.component';
import { ListviewsComponent } from './listview/listview.component';
import { ProfileComponent } from './profile/profile.component';
import { ForgotPasswordComponent } from './login/forgot-password/forgot-password.component';
import { ResetPasseordComponent } from './login/reset-passeord/reset-passeord.component';
import { RosteringOldRouting } from './rostering-old/rostering-old.routing';
import { RosteringRouting } from './rostering/rostering.routing';
import { CampaignsRouting } from './campaigns/campaigns.routing';
import { SosPanelRouting } from './sos-panel/sos-panel.routing';
import { TransportManagerUpdatePasswordComponent } from './login/transport-manager-update-password/transport-manager-update-password.component';



export const TransportManggerRouting = [
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    { path: 'login', component: LoginComponent },
    { path: 'forgot-password', component: ForgotPasswordComponent },
    { path: 'reset-password', component: ResetPasseordComponent },
    { path: 'update-password', component: TransportManagerUpdatePasswordComponent },
    { path: 'profile', component: ProfileComponent },
    { path: 'dashboard-1', component: DashboardOldComponent },
    
    { path: 'dashboard', component: DashboardComponent },
    { path: 'request-component', component: RequestsComponent },
    { path: 'rostering-old', children: RosteringOldRouting },
    { path: 'rostering', children: RosteringRouting },
    // { path: 'request-component', component: RequestsComponent },
    { path: 'reports', children: ReportsRouting },
    { path: 'campaigns', children: CampaignsRouting },
    //{ path: 'sospanel', component: SosPanelComponent },
    { path: 'sospanel', children: SosPanelRouting },
    { path: 'setting', component: SettingsComponent },
    { path: 'support-desk', children: SupportDeskRouting },
    { path: 'information', children: InformationRouting },
    { path: 'request', children: RequestRouting },
    { path: 'vehicle-track', component: LiveVehicleTrackingComponent },
    { path: 'listview', component: ListviewsComponent },
];
